<template>
    <div>
        <el-card>
            <div class="tableBox">
                <div>
                    <div>
                        <span>细化发布</span>
                        <span>发布状态统计</span>
                    </div>
                    <img src="../../../../assets/icon_logo.png">
                </div>
                <div>
                    <div>
                        <div style="position:relative;height:20px;">
                            <div class="helpDiv" style="position: absolute;top:-20px">
                                <b class="helpI"></b>
                                <a href="https://wiki.autoai.com/pages/viewpage.action?pageId=26157093"
                                target="_blank"
                                class="helpA">
                                    帮助指引
                                </a>
                            </div>
                        </div>
                        <el-form :inline="true" class="search-form">
                            <el-form-item label="">
                                <el-date-picker
                                    ref="dataPicker"
                                    @change="changeData"
                                    v-model="value"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    value-format="yyyy-MM-dd">
                                </el-date-picker>
                            </el-form-item>
                            <el-button class="changeTime" type="primary" @click="selectData">修改时间</el-button>
                            <el-form-item label="人员名称">
                                <div class="el-form__inline">
                                    <el-input type="text" placeholder="" disabled v-model="personList"></el-input>
                                    <router-link :to="{ path:'/requesterList',query: { moreSelect:isMoreSelect,tit:'选择人员',callback:getPersonList } }">
                                        <el-button type="primary" class="iconfont icon-gengduo icon"></el-button>
                                    </router-link>
                                </div>
                            </el-form-item>
                            <el-button type="primary" @click="getExcel">导出excel</el-button>
                        </el-form>
                    </div>
                    <div class="tableClass">
                        <div>
                            <el-table id="table-content"
                                :data="tableData">
                                <el-table-column prop="name" label="人员名称"></el-table-column>
                                <el-table-column prop="dengji" label="已登记"></el-table-column>
                                <el-table-column prop="pinggu" label="已评估"></el-table-column>
                                <el-table-column prop="shouquan" label="已授权"></el-table-column>
                                <el-table-column prop="jihua" label="已计划"></el-table-column>
                                <el-table-column prop="jieshu" label="已结束"></el-table-column>
                                <el-table-column prop="guancha" label="观察中"></el-table-column>
                                <el-table-column prop="huigu" label="已回顾"></el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
                <div>
                    <div>
                        <span>生成时间:</span>
                        <span>{{getMes.generateTime}}</span>
                    </div>
                    <span>itsmops.autoai.com</span>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>

    import services from '../reportRefining.service';
    import { export_json_to_excel } from '../../../../core/utils/Export2Excel';
    export default {
        data: function () {
            return {
                tableData: [],
                sortList:['descending', 'ascending'],
                value:'',
                getMes:{},
                isMoreSelect:true,
                personList:'',
                personIdList:[],
            }
        },
        mounted(){
            this.value = services.getDefaultData();
            this.getData();
        },
        methods:{
            getPersonList(data){//获取选中的人员信息
                this.personIdList = '';
                this.personList = '';
                let userIdArray = [];
                let nameArray = [];
                data.forEach((item,index)=>{
                    userIdArray.push(item.userid);
                    nameArray.push(item.name);
                })
                this.personIdList = userIdArray;
                this.personList = nameArray.toString();
                this.getData();
            },
            getExcel(){
                services.exportToExcel(`发布状态统计${this.value[0]}—${this.value[1]}`);
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            getData(){//获取数据
                let params = {
                    startTime: this.value[0],
                    stopTime: this.value[1],
                    group:'ops',
                }
                let sendData = {
                    users:[]
                };
                if(this.personList){
                    sendData.users = this.personIdList;
                }
                services.deployDeployStatusList(params,sendData).then(res=>{
                    this.getMes = res;
                    this.tableData = res.tableData;
                })
            },
            selectData(){//点击修改日期 日期控件自动聚焦
                let selData = this.$refs.dataPicker;
                selData.focus();
            },
            changeData(){//选择日期
                this.getData();
            },
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .el-form__inline{
        display: flex;
    }
    .changeTime{
        margin-right: 20px;
    }
</style>
